/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Mahesh        21/11/2020      3600: language translation issue
*********************************************************************************/
import imageTelemedicine from 'assets/img/telemedicine.png'
import imageExpressClinic from 'assets/img/express-clinic.png'
import imageHouseVisit from 'assets/img/house-visit.png'
import imageUrgentCare from 'assets/img/urgent-care.png'
import imageClinic from 'assets/img/clinic.png'
import imageEmergencyRoom from 'assets/img/emergency-room.png'
import imageConciergeCare from 'assets/img/concierge-care.png'
import imageTelemedicineThumb from 'assets/img/thumb-tele@2x.png'
import imageExpressClinicThumb from 'assets/img/thumb-express@2x.png'
import imageHouseVisitThumb from 'assets/img/thumb-house@2x.png'
import imageUrgentCareThumb from 'assets/img/thumb-urgent@2x.png'
import imageClinicThumb from 'assets/img/thumb-clinic@2x.png'
import imageEmergencyRoomThumb from 'assets/img/thumb-emergency@2x.png'
import imageConciergeCareThumb from 'assets/img/thumb-concierge@2x.png'
// Used in state/triage/score/recommended, then rendered in find-care-options/care-options
import {Trans} from 'react-i18next'
const availableCareOptions = [
  {
    src: imageTelemedicine,
    srcThumb: imageTelemedicineThumb,
    alt: 'Telemedicine',
    altText: <Trans i18nKey="findcareoption.Careoptions.telemedicine.Telemedicine">Telemedicine1</Trans>,
    text: <Trans i18nKey="findcareoption.Careoptions.telemedicine.text">Instantly connect with a licensed doctor within minutes by phone or online wherever you are.</Trans>,
    bgColor: '#FFF5D6',
    linkText: <Trans i18nKey="findcareoption.Careoptions.telemedicine.linktext">Get an appointment</Trans>,
    cashLess: true
  },
  {
    src: imageExpressClinic,
    srcThumb: imageExpressClinicThumb,
    alt: 'Express Clinic',
    altText: <Trans i18nKey="findcareoption.Careoptions.expressclinic.express">Express Clinic</Trans>,
    text: <Trans i18nKey="findcareoption.Careoptions.expressclinic.text">Staffed by licensed nurse practitioners, Express Clinics can save you time and money.</Trans>,
    bgColor: '#E8F7FF',
    linkText: <Trans i18nKey="findcareoption.Careoptions.expressclinic.linktext">Choose a clinic</Trans>
  },
  {
    src: imageHouseVisit,
    srcThumb: imageHouseVisitThumb,
    alt: 'House Visit',
    altText: <Trans i18nKey="findcareoption.Careoptions.housevisit.House_Visit">House Visit</Trans>,
    text:  <Trans i18nKey="findcareoption.Careoptions.housevisit.text">A licensed medical professional will come to your home or hotel.</Trans>,
    bgColor: '#E8EBFF',
    linkText: <Trans i18nKey="findcareoption.Careoptions.housevisit.linktext">Get an appointment</Trans>,
    cashLess: true
  },
  {
    src: imageUrgentCare,
    srcThumb: imageUrgentCareThumb,
    alt: 'Urgent Care',
    altText: <Trans i18nKey="findcareoption.Careoptions.UrgentCare.Urgent_Care">Urgent Care</Trans>,
    text:  <Trans i18nKey="findcareoption.Careoptions.UrgentCare.text">Best for treating minor medical conditions before they become life-threatening.</Trans>,
    bgColor: '#EFFFEF',
    linkText: <Trans i18nKey="findcareoption.Careoptions.UrgentCare.linktext">Choose a clinic</Trans>
  },
  {
    src: imageClinic,
    srcThumb: imageClinicThumb,
    alt: 'Clinic',
    altText: <Trans i18nKey="findcareoption.Careoptions.clinic.Clinic">Clinic</Trans>,
    text: <Trans i18nKey="findcareoption.Careoptions.clinic.text">Staffed by physicians and nurse practitioners to treat minor medical conditions.</Trans>,
    bgColor: '#FFE1D6',
    linkText: <Trans i18nKey="findcareoption.Careoptions.clinic.linktext">Choose a clinic</Trans>
  },
  {
    src: imageEmergencyRoom,
    srcThumb: imageEmergencyRoomThumb, 
    alt: 'Emergency Room',
    altText: <Trans i18nKey="findcareoption.Careoptions.emergency.Emergency_Room"> Emergency Room</Trans>,
    text:  <Trans i18nKey="findcareoption.Careoptions.emergency.text">When no other care will do, 24/7 access to medical professionals to treat all ailments.</Trans>,
    bgColor: '#FFF5D6',
    linkText: <Trans i18nKey="findcareoption.Careoptions.emergency.linktext">Choose an emergency room</Trans>
  },
  {
    src: imageConciergeCare,
    srcThumb: imageConciergeCareThumb,
    //alt: <Trans i18nKey="findcareoption.Careoptions.Concierge.text">Concierge Care</Trans>,
    alt:'Concierge Care',
    altText: <Trans i18nKey="findcareoption.Careoptions.Concierge.Concierge_Care">Concierge Care</Trans>,
    text: <Trans i18nKey="findcareoption.Careoptions.Concierge.text">If you can't find a right match, our agents will reach out to you with the appropriate care.</Trans>,
    bgColor: '#FFEDED',
    linkText: <Trans i18nKey="findcareoption.Careoptions.Concierge.linktext">LET US HELP</Trans>,
    cashLess: true
    },
    {
        src: imageExpressClinic,
        srcThumb: imageExpressClinicThumb,
        alt: 'Retail Clinic',
        altText: <Trans i18nKey="findcareoption.Careoptions.retailclinic.Retail_Clinic">Retail Clinic</Trans>, 
        text: <Trans i18nKey="findcareoption.Careoptions.retailclinic.text">Staffed by licensed nurse practitioners, Express Clinics can save you time and money.</Trans>,
        bgColor: '#E8F7FF',
        linkText: <Trans i18nKey="findcareoption.Careoptions.retailclinic.linktext">Choose a clinic</Trans>,
        isCovidTestingAvailable:true
    },
    {
      src: imageUrgentCare,
      srcThumb: imageUrgentCareThumb,
      alt: 'Medical Facility',
      altText: <Trans i18nKey="findcareoption.Careoptions.MedicalFacility.Medical_Facility">Medical Facility</Trans>,
      text:  <Trans i18nKey="findcareoption.Careoptions.MedicalFacility.text">Best for treating minor medical conditions before they become life-threatening.</Trans>,
      bgColor: '#EFFFEF',
      linkText: <Trans i18nKey="findcareoption.Careoptions.MedicalFacility.linktext">Choose a Facility</Trans>
    }
]

export const numberOfCards = availableCareOptions.length

export default availableCareOptions
